import { ChangeDetectionStrategy, Component, inject, Injector } from '@angular/core';
import { MpSelfEnrolmentFormService } from './mp-self-enrolment-form-service';
import { MpSelfEnrolmentNavService } from './mp-self-enrolment-nav-service';
import { map } from 'rxjs/operators';
import { MpSelfEnrolmentFlowStepEnum } from './mp-self-enrolment-flow-step.enum';
import { Router } from '@angular/router';
import { Routes } from '../../../../../routes/routes';
import { ComponentCanDeactivate } from '../../../../../models/protocols/component-can-deactivate';
import { ConfirmationOptions } from '../../../../../models/shared/stylesheet/confirmation-options';
import { ModalAbandon } from '../../../../../modals/modal-abandon';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-mp-self-enrolment',
  templateUrl: './mp-self-enrolment.component.html',
  styleUrls: ['./mp-self-enrolment.component.scss'],
  providers: [MpSelfEnrolmentFormService, MpSelfEnrolmentNavService],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MpSelfEnrolmentComponent implements ComponentCanDeactivate {
  private navService = inject(MpSelfEnrolmentNavService);
  private formService = inject(MpSelfEnrolmentFormService);
  private router = inject(Router);
  private ngbModal = inject(NgbModal);
  private injector = inject(Injector);

  public currentStep$ = this.navService.currentStep$;
  public currentStepComponent$ = this.navService.currentStepComponent$;
  public showBackToLogin$ = this.currentStep$.pipe(
    map(step => step === MpSelfEnrolmentFlowStepEnum.PersonalInformation)
  );

  public goBack(): void {
    this.router.navigate([Routes.signIn()]).then();
  }

  public canDeactivate(): Promise<boolean> | boolean {
    if (this.navService.canDeactivate) {
      return true;
    } else {
      const opts = new ConfirmationOptions();
      opts.title = $localize`Are you sure you want to leave?`;
      opts.bodyText = $localize`Your progress will be discarded.`;
      opts.cancelText = $localize`Cancel`;
      opts.continueText = $localize`Continue to Leave`;
      return ModalAbandon.open(this.ngbModal, this.injector, opts);
    }
  }
}
